export default {
    header: 'Calendar',
    myCalendar: 'My Calendar',
    noCalendar: 'Your career services has not activated the calendar feature yet.',
    goBackBtn: 'Go back',
    calendarNotReady: 'The "my calendar" functionality is not ready yet. Coming soon!',
    noUpcomingAppointments: 'You have no upcoming appointments.',
    appointmentMissing: 'Appointment not active',
    appointmentNotActive:
        'Sorry, you have tried to view an appointment that is non-existent or not active.',
    appointmentNotHavingAvailability:
        'Sorry, this appointment has no availability at the moment. Check back later.',
    appointmentMissingRules: 'Appointment has no availability',
    needToCompleteProfile: 'Complete your profile',
    noUpcomingAppointmentsPleaseBook: 'Book an appointment to unlock your calendar.',
    bookAppointment: 'Book appointment',
    upcomingAppointments: 'Upcoming appointments',
    bookAnotherAppointment: 'Book an appointment',
    attendedAppointments: 'Appointments you have attended',
    aboutAppointments: {
        header: 'About appointments',
        button: 'About',
        //Note: Here we would want some sort of article functionality later on, for easy edit in CMS
        block1: {
            header: 'What is an appointment?',
            paragraph1:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            paragraph2:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        },
        block2: {
            header: 'Who can I contact for more information?',
            paragraph1:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            paragraph2:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        },
    },
    listAppointments: {
        error: {
            title: 'Was not able to load your appointments',
            description: 'Please try again later.',
        },
    },
    bookAnAppointment: 'Book An Appointment',
    backToCalendarBtn: 'Back to calendar',
    backToBookingBtn: 'Back to appointment list',
    firstAvailable: 'First available',
    loadingAppointment: 'Loading ...',
    bookingStatus: {
        accepted: 'Accepted',
        pending: 'Pending',
        declined: 'Declined',
        tentative: 'Tentative',
    },
    bookModal: {
        title: 'Confirm booking',
        with: 'With',
        confirm: 'Confirm',
        continue: 'Continue',
        cancel: 'Close',
        first: {
            title: 'This is your first appointment',
            description:
                'To ensure you get the event invitation, please confirm that you have access to a personal calendar through this e-mail account',
            ok: 'OK',
            wrongEmail: 'Wrong e-mail?',
        },
        changeEmail: {
            title: 'Select your calendar e-mail',
            inputPlaceholder: 'Type email ...',
            ok: 'OK',
            back: 'Use default',
        },
        unknownErrorHeader: 'An error occured when trying to book',
        unknownErrorBody:
            'Please try to book another time, and if this does not work contact support.',
        confirmationHeader: 'Your appointment is booked!',
        bookedTheFollowing: 'Details:',
        emailWillBeSent: 'An e-mail will be sent to',
        withConfirmation: 'asking you to confirm your attendance.',
    },
    deleteBookModal: {
        title: 'Confirm cancellation',
        content: 'Are you sure you want to cancel this appointment?',
        delete: 'Delete',
        cancel: 'Cancel',
        error: {
            title: 'An error occured',
            description: 'Please try again later.',
        },
    },
    dateDetailsModal: {
        title: 'Appointments on',
    },
    completedYourProfile: 'You need to complete your profile to get access to the calendar system',
    toMyProfile: 'Edit my profile',
};
